import React, { useEffect, useState } from "react";
import {
  Stepper,
  Step,
  Button,
  TextField,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  StepLabel,
  IconButton,
  Alert,
} from "@mui/material";
import { appSelector } from "../redux/selector";
import { resetAction } from "../redux/action";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import InputMask from "react-input-mask";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Key from "../../../src/clientVariables.json";
import Avatar from "@mui/material/Avatar";
import { userSelector } from "../../../src/Components/user-redux/selector";
import { useDispatch, useSelector } from "react-redux";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import EditIcon from "@mui/icons-material/Edit";
import { companyUpdateAction } from "./redux/action";
import { settingsSelector } from "./redux/selector";

const Recruterprofile = ({ setIsEditClicked, showPasswordSettings }) => {
  const dispatch = useDispatch();
  const {
    statesList,
    citiesList,
    result,
    countriesList,
    jobTypesList,
    addCandidateResult,
  } = useSelector(appSelector);

  const { user } = useSelector(userSelector);
  const { userDetail, updated } = useSelector(settingsSelector);

  const [openStepper, setOpenStepper] = useState(true);
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState();
  const [error, setError] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [success, setSuccess] = useState("");
  const [hovered, setHovered] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");
  const [profileImageName, setProfileImageName] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    dispatch(resetAction());
    // Set initial image if available
    if (user?.image && user?.id) {
      const url = `https://${Key.aws_bucket_bench}.s3.amazonaws.com/attachments/user_${user.id}/profileimages/${user.image}`;
      setProfileImage(url);
      setProfileImageName(user.image);
    }
    const objData = {
      id: user.id,
      companyid: user.companyid || 0,
      full_name: user.full_name,
      url: user.url || "",
      domain_name: "",
      email_domain: "",
      aboutcompany: "",
      contactname: user.contactname || "",
      contactphone: user.contactphone || "",
      contactemail: user.contactemail || "",
      company_country: user.company_country || 233,
      company_state: user.company_state || "",
      company_city: user.company_city || "",
      company_zipcode: user.company_zipcode || "",
      company_address1: user.company_address1 || "",
      company_address2: user.company_address2 || "",
      email: user.username || "",
      phone_number: user.phone_number || "",
      state: user.state || "",
      city: user.city || "",
      zipcode: user.zipcode || "",
      address: user.address || "",
      companyName: user.companyname || user.company_name || "",
      linkedinUrl: user.linkedinUrl || user.linkedin_url || "",
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    };
    //console.log(user);
    //console.log(objData);
    setFormData(objData);
  }, [user]);
  //console.log(activeStep);

  useEffect(() => {
    console.log(activeStep);
    if (updated && activeStep == 0) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  }, [userDetail]);

  useEffect(() => {
    if (showPasswordSettings) {
      setActiveStep(1); // Set activeStep to 1 when showPasswordSettings is true
    }
  }, [showPasswordSettings]);

  const handleSubmit = async () => {
    const ret4 = formData?.url?.replace("www.", "");
    const ret3 = ret4.replace("http://", "");
    const ret2 = ret3.replace("https://", "");
    const ret1 = ret2.replace("http://www.", "");
    const finalurl = ret1.replace("https://www.", "");
    const domain_name = finalurl.replace("/", "");
    const forEmailDomain = formData?.email;
    const emailDomainArr = forEmailDomain.split("@");
    const email_domain = emailDomainArr[1];
    // Data to be sent in POST request
    const postData = {
      id: formData?.id,
      companyid: formData?.companyid || 0,
      full_name: formData?.full_name,
      url: formData?.url || "",
      domain_name: domain_name,
      email_domain: email_domain,
      aboutcompany: "",
      contactname: formData?.contactname || "",
      contactphone: formData?.contactphone || "",
      contactemail: formData?.contactemail || "",
      company_country: formData?.company_country || 233,
      company_state: formData?.company_state || "",
      company_city: formData?.company_city || "",
      company_zipcode: formData?.company_zipcode || "",
      company_address1: formData?.company_address1 || "",
      company_address2: formData?.company_address2 || "",
      email: formData?.email || "",
      phone_number: formData?.phone_number || "",
      state: formData?.state || "",
      city: formData?.city || "",
      zipcode: formData?.zipcode || "",
      address: formData?.address || "",
      companyName: formData?.companyName || "",
      usertype: user?.usertype,
      image: profileImageName || user?.image || "",
      linkedin_url: formData?.linkedinUrl || formData?.linkedin_url || "",
    };

    //console.log(postData);
    dispatch(companyUpdateAction(postData));
  };

  const steps = ["User Details", "Change Password"];
  const lowerStep = [
    "We'd love to hear from you. Please fill out this form",
    "Kindly update your password to enhance security",
  ];

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleChangePassword = async (event) => {
    event.preventDefault();
    const { currentPassword, newPassword, confirmPassword } = formData;

    // Clear previous messages
    setError("");
    setSuccess("");

    // Validations (simplified)
    if (newPassword !== confirmPassword) {
      setError("New passwords don't match");
      return;
    }
    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }

    try {
      const response = await fetch(`${Key.domain}/common/change_password`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: user?.username,
          currentPassword: currentPassword,
          newPassword: newPassword
        }),
      });

      const result = await response.json();

      if (response.ok && result.success === 1) {
        setSuccess("Password changed successfully!");
        setIsEditClicked(false);
        // Optional: Force logout after password change
        // await logout();
      } else {
        setError(result.error || "Failed to change password");
      }
    } catch (error) {
      setError("Network error. Please try again.");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setProfileImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
    if (!file) {
      console.log("No file selected");
      return;
    }

    // Validate file type (image)
    if (!file.type.startsWith("image/")) {
      setUploadError("Please select an image file");
      console.log("Invalid file type");
      return;
    }

    // Validate file size (5MB limit)
    if (file.size > 5 * 1024 * 1024) {
      setUploadError("Image size should be less than 5MB");
      console.log("File too large");
      return;
    }

    // Preview the selected image immediately
    const previewUrl = URL.createObjectURL(file);
    setProfileImage(previewUrl);

    setIsUploading(true);
    setUploadError("");
    const formData = new FormData();
    formData.append("profile_image", file);
    formData.append("user_id", user.id);

    try {
      //console.log("Uploading file...", file.name);
      const response = await fetch(`${Key.domain}/user/profile/image_upload`, {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to upload image");
      }
      const data = await response.json();

      if (data.name) {
        setProfileImageName(data.name);
        // Do NOT update the preview to S3 URL here; keep the local preview until save/reload
      } else {
        console.error("Image URL not returned or invalid");
      }

      //console.log("Upload successful:", data);
      setSuccess("Profile picture updated successfully");
    } catch (error) {
      console.error("Error during upload:", error);
      setUploadError(error.message || "Failed to upload image");
    } finally {
      setIsUploading(false);
    }
  };

  const renderStepContentRecruiter = (step) => {
    switch (step) {
      case 0:
        return (
          <Box>
            <Box sx={{ margin: "20px 40px 0 40px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 2,
                  position: "relative",
                }}
              >
                <label>
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={handlePhotoUpload}
                    id="profile-upload"
                  />
                  {profileImage ? (
                    <Box sx={{ position: "relative", width: 80, height: 80 }}>
                      <Avatar
                        src={profileImage}
                        sx={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "50%",
                          transition: "transform 0.2s ease, opacity 0.2s ease",
                          cursor: "pointer",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          opacity: hovered ? 0.8 : 1,
                        }}
                        onMouseOver={() => setHovered(true)}
                        onMouseOut={() => setHovered(false)}
                        onClick={() =>
                          document.getElementById("profile-upload").click()
                        }
                        alt="Profile"
                      />
                      {/* Show Edit Icon when hovered */}
                      <IconButton
                        color="primary"
                        size="small"
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          opacity: hovered ? 5 : 0,
                          visibility: hovered ? "visible" : "hidden",
                          backgroundColor: "rgba(255, 255, 255, 0.7)",
                          borderRadius: "50%",
                          transition: "opacity 0.3s ease, visibility 0.3s ease",
                          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                          "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.7)",
                          },
                        }}
                        onMouseOver={() => setHovered(true)}
                        onMouseOut={() => setHovered(false)}
                        onClick={() =>
                          document.getElementById("profile-upload").click()
                        }
                      >
                        <EditIcon />
                      </IconButton>
                    </Box>
                  ) : (
                    <IconButton
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: 80,
                        height: 80,
                        cursor: "pointer",
                        padding: 0,
                        borderRadius: "50%",
                        backgroundColor: "rgb(233, 236, 239)",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        transition: "transform 0.2s ease",
                        "&:hover": {
                          transform: "scale(1.1)",
                        },
                      }}
                      onClick={() =>
                        document.getElementById("profile-upload").click()
                      }
                    >
                      <AddAPhotoOutlinedIcon
                        style={{
                          fontSize: "40px",
                          color: "rgb(59, 66, 73)",
                          transition: "transform 0.2s ease",
                          transform: "rotateY(180deg)",
                        }}
                        onMouseOver={(e) =>
                        (e.currentTarget.style.transform =
                          "scale(1.001) rotateY(180deg)")
                        }
                        onMouseOut={(e) =>
                        (e.currentTarget.style.transform =
                          "scale(1) rotateY(180deg)")
                        }
                      />
                    </IconButton>
                  )}
                </label>
              </Box>
            </Box>

            <TextField
              label="Name"
              name="full_name"
              value={formData?.full_name}
              onChange={handleInputChange}
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <TextField
              label="Email"
              name="email"
              value={formData?.email}
              disabled
              onChange={handleInputChange}
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />

            <InputMask
              mask="(999) 999-9999"
              value={formData?.phone_number}
              onChange={handleInputChange}
            >
              {() => (
                <TextField
                  label="Phone Number"
                  name="phone_number"
                  fullWidth
                  margin="normal"
                  sx={{
                    width: "calc(100% - 80px)",
                    margin: "9px 40px",
                    "&:hover": {
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.3s ease-in-out",
                    },
                  }}
                />
              )}
            </InputMask>
            <TextField
              label="LinkedIn URL"
              name="linkedinUrl"
              value={formData?.linkedinUrl}
              onChange={handleInputChange}
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <FormControlLabel
              sx={{ margin: "9px 30px" }}
              control={<Checkbox defaultChecked />}
              label={
                <span>
                  You agree to{" "}
                  {/* <Typography
                    component="span"
                    sx={{ textDecoration: "underline" }}
                  > */}
                  Terms and Conditions
                  {/* </Typography> */}
                </span>
              }
            />
          </Box>
        );
      case 1:
        return (
          <Box>
            {error && (
              <Alert
                severity="error"
                sx={{
                  width: "calc(100% - 80px)",
                  margin: "9px 40px",
                }}
              >
                {error}
              </Alert>
            )}
            {success && (
              <Alert
                severity="success"
                sx={{
                  width: "calc(100% - 80px)",
                  margin: "9px 40px",
                }}
              >
                {success}
              </Alert>
            )}
            <TextField
              label="Current Password"
              name="currentPassword"
              type={showCurrentPassword ? "text" : "password"}
              margin="normal"
              value={formData?.currentPassword || ""}
              onChange={handleInputChange}
              autoComplete="new-password"
              InputProps={{
                  endAdornment: (
                      <InputAdornment position="end">
                          <IconButton
                              onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                              edge="end"
                          >
                              {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                      </InputAdornment>
                  ),
              }}
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "#1976d2", // Change border color on hover
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.3s ease-in-out",
                  },
                },
              }}
            />

            <TextField
              label="New Password"
              name="newPassword"
              type={showNewPassword ? "text" : "password"}
              margin="normal"
              value={formData?.newPassword || ""}
              onChange={handleInputChange}
              autoComplete="new-password"
              InputProps={{
                  endAdornment: (
                      <InputAdornment position="end">
                          <IconButton
                              onClick={() => setShowNewPassword(!showNewPassword)}
                              edge="end"
                          >
                              {showNewPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                      </InputAdornment>
                  ),
              }}
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <TextField
              label="Confirm Password"
              name="confirmPassword"
              type={showConfirmPassword ? "text" : "password"}
              margin="normal"
              value={formData?.confirmPassword || ""}
              onChange={handleInputChange}
              autoComplete="new-password"
              InputProps={{
                  endAdornment: (
                      <InputAdornment position="end">
                          <IconButton
                              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                              edge="end"
                          >
                              {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                      </InputAdornment>
                  ),
              }}
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 600,
        margin: "auto",
        mt: 4,
        backgroundColor: "rgb(245 245 245)",
        borderRadius: 8,
        overflow: "hidden",
      }}
    >
      <Dialog
        open={openStepper}
        fullWidth
        maxWidth="sm"
        sx={{
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <DialogTitle>
          {activeStep > 0 && (
            <ArrowBackIcon onClick={handleBack} sx={{ cursor: "pointer" }} />
          )}

          <span
            onClick={() => {
                if (setIsEditClicked) setIsEditClicked(false);
                setOpenStepper(false);
            }}
            style={{ cursor: "pointer", float: "right" }}
          >
            Skip <KeyboardArrowRightIcon />
          </span>
        </DialogTitle>
        <DialogContent>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel>{ }</StepLabel>
              </Step>
            ))}
          </Stepper>

          <Typography
            variant="h5"
            sx={{ textAlign: "center", marginTop: "20px", fontWeight: 600 }}
          >
            {steps[activeStep]}
          </Typography>

          <Typography
            sx={{
              textAlign: "center",
              marginTop: "20px",
              color: "rgb(102, 112, 133)",
              fontSize: "16px",
            }}
          >
            {lowerStep[activeStep]}
          </Typography>
          <Box sx={{ mt: 4 }}>{renderStepContentRecruiter(activeStep)}</Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
            {activeStep === steps.length - 1 ? (
              <Button
                onClick={handleChangePassword}
                variant="contained"
                color="primary"
                sx={{ width: "100%", margin: "0 40px 40px 40px" }}
              >
                Change Password
              </Button>
            ) : (
              <Button
                sx={{ width: "100%", margin: "0 40px 40px 40px" }}
                onClick={() => handleSubmit()}
                variant="contained"
                color="primary"
              >
                Save
              </Button>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Recruterprofile;
